// extracted by mini-css-extract-plugin
module.exports = {"Section":"DetailsSection_Section__2R2Mh","SectionLast":"DetailsSection_SectionLast__1BqrQ","Title":"DetailsSection_Title__qZeHl"};